module.exports = __webpack_public_path__ + "static/media/longbeachsmall.0fe6f979.png";